/**
 * Created by Owner on 2016/7/26.
 */
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map'
import {AppConfigService} from "./appConfig.service";
import { LotteryPage } from "../pages/lottery/lottery";

@Injectable()
export class LotteryService {

    constructor(private configService: AppConfigService) {}

    getBalance(fnCallback: any) {
        let postParams = {lotteryid: LotteryPage.lotteryId};
        this.lotteryBalance(postParams, null).then(data => {
            if (data["balance"]) {
                fnCallback && fnCallback(data);
            }
        });
    }

    /**
     * 投注初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    lotteryInit(data, nav: any) {
        data["flag"] = data["flag"] + "Bean";
        return this.configService.getUserService(data, nav);
    }

    /**
     * 获取彩余额
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    lotteryBalance(data = {}, nav: any) {
        if (!data["lotteryid"]) {
            delete data["lotteryid"];
        }
        data["flag"] = "balance";
        return this.configService.getLotteryService(data, nav);
    }

    /**
     * 获取开奖号码
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    getOpenWinRecored(data = {}, nav: any) {
        data["flag"] = "gethistory";
        return this.configService.getLotteryService(data, nav);
    }

    /**
    * 投注
    * @param data
    * @param nav
    * @returns {Promise<T>}
    */
    lotteryBet(data, nav: any) {
        //data["flag"] = "UIWinOpenNumberBean";
        return this.configService.getLotteryService(data, nav);
    }

    lotteryCheck_DeMBDacBiet(data, nav: any) {
        data["flag"] = "checkDualNumber";
        return this.configService.getDualNumber(data, nav);
    }

    /**
    * 查看最近开奖记录
    * @param data
    * @param nav
    * @returns {Promise<T>}
    * {
    * reslist:[{
    *    winnumber:"92471"
    *    issue:"0455期"
    * }]
    * }
    */
    lotteryWinOpenNumber(data, nav: any) {
        data["flag"] = "UIWinOpenNumberBean";
        return this.configService.getUserService(data, nav);
    }

    /**
    * 查看最近开奖记录
    * @param data
    * @param nav
    * @returns {Promise<T>}
    * {
    * reslist:[{
    *    winnumber:"92471"
    *    issue:"0455期"
    * }]
    * }
    */
    lotteryMMCWinOpenNumber(data, nav: any) {
        data["flag"] = "mmcwnum";
        return this.configService.getLotteryService(data, nav);
    }

    /**
    * 读取当前期号信息
    * @param data
    * @param nav
    * @returns {Promise<T>}
    */
    lotteryCurrentIssue(data, nav: any) {
        data["flag"] = "read";
        return this.configService.getLotteryService(data, nav);
    }

    /**
    * 读取投注记录
    * @param data
    * @param nav
    * @returns {Promise<T>}
    * {
    *  reslist:
    * }
    */
    lotteryRecordBean(data, nav: any) {
        data["flag"] = "GameRecordBean_btnSearch";
        return this.configService.getUserService(data, nav);
    }

    /**
     * 读取投注记录下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    lotteryNextRecordBean(data, nav: any) {
        data["flag"] = "GameRecordBean_nextPage";
        return this.configService.getUserService(data, nav);
    }

    /**
    * 查看投注记录详情
    * @param data
    * @param nav
    * @returns {Promise<T>}
    * {
    *betinfo{
    * loginname:会员名
    * lotteryname：游戏名称
    * status：中奖状态（number）
    * statusname：中奖状态（string）
    * issue：开奖期号
    * inserttime： 投注时间
    * point：动态奖金返点（不等于1显示）
    * betnumber：注单数
    * betcontent：内容摘要
    * codes：选好明细
    * betmodle：（1-4,元角分厘）
    * multiple:倍数
    * amount：下注金额
    * winnumber：开奖号码
    * wintimes：中奖注数
    * bonus：奖金
    * source：（1:追号，0：非）
    * }
    * }
    */
    lotteryRecordBeanInfo(data, nav: any) {
        data["flag"] = "BetRecordBean";
        return this.configService.getUserService(data, nav);
    }

    /**
     * 撤单
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    lotteryCancelBet(data, nav: any) {
        data["flag"] = "GameRecordBean_cancelBet";
        return this.configService.getUserService(data, nav);
    }

    /**
     * 追号记录
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    lotteryTraceList(data, nav: any) {
        data["flag"] = "searchIssueList";
        return this.configService.getMobileService(data, nav);
    }

    lotteryAllWinOpenNumber(data, nav: any) {
        data["flag"] = "allwinopennumber";
        return this.configService.getLotteryService(data, nav);
    }

    lotteryWinOpenNumberList(data, nav: any) {
        data["flag"] = "YLFXBean";
        return this.configService.getUserService(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/lottery.services.ts